import { FC, useState } from 'react'
import mclasses from '@pages/Admin/CRM/styles/modal.module.css'
import iclasses from '@pages/Admin/CRM/styles/input.module.css'
import classes from './index.module.css'
import Modal from '@common/Modal'
import { classApi } from '@/api'
import { useAddAlert } from '@/hooks/useAddAlert'
import { IcoRemove } from '@/utils/icons'
import Button from '@UI/New/Button'
import { isError } from '@/helpers/checkQuery'
import { InputNew } from '@UI/InputNew'
import cn from 'classnames'
import { ClassFolder } from '../../ClassesPageHeader'

interface CreateEditFolderModalProps {
  folder?: ClassFolder
  open: boolean
  onClose: () => void
  onSuccess?: (folder: ClassFolder) => void
  // onDismiss: () => void
}

const CreateEditFolderModalContent: FC<CreateEditFolderModalProps> = ({
  folder,
  open,
  onSuccess,
  onClose,
}) => {
  const addAlert = useAddAlert()
  const [submitting, setSubmitting] = useState(false)
  const [folderName, setFolderName] = useState<string | null>(
    folder?.title || null,
  )

  const handleConfirm = async () => {
    if (folder === undefined || folder === null) handleCreateFolder()
    else handlerEditFolder(folder.id)
  }

  const handleCreateFolder = async () => {
    setSubmitting(true)
    classApi
      .addFolder({ title: folderName })
      .then((res) => {
        if (isError(res)) throw new Error()

        onSuccess && onSuccess(res.data.data)
        addAlert({
          title: 'Успешно',
          text: `Успешно создана папка`,
          type: 'success',
        })
        onClose()
      })
      .catch((error) => {
        addAlert({
          title: 'Ошибка',
          text: 'Ошибка создания папки',
          type: 'error',
        })
      })
      .finally(() => setSubmitting(false))
  }

  const handlerEditFolder = async (id: number) => {
    setSubmitting(true)
    classApi
      .editFolder(id, { title: folderName })
      .then((res) => {
        if (isError(res)) throw new Error()

        onSuccess && onSuccess(res.data.data)
        addAlert({
          title: 'Успешно',
          text: `Успешно изменено название папки`,
          type: 'success',
        })
        onClose()
      })
      .catch((error) => {
        addAlert({
          title: 'Ошибка',
          text: 'Ошибка редактирования папки',
          type: 'error',
        })
      })
      .finally(() => setSubmitting(false))
  }

  return (
    <div className={mclasses.modalContainer}>
      <div className={mclasses.modalHeader}>
        <div className={mclasses.modalTitleContainer}>
          <span className={mclasses.modalHeaderTitle}>
            {folder ? 'Редактирование папки' : 'Создание папки'}
          </span>
        </div>
        <div className={mclasses.closeIcon} onClick={() => onClose()}>
          <IcoRemove />
        </div>
      </div>
      <div className={mclasses.formWrapper}>
        <div>
          <p className={mclasses.label}>Название папки</p>
          {/*@ts-ignore*/}
          <InputNew
            className={iclasses.newInputDesign}
            placeholder={folder ? 'Название новой папки' : 'Название папки'}
            value={folderName ?? ''}
            onChange={(e: any) => setFolderName(e.currentTarget.value)}
            validate={folderName !== null && !folderName.length}
            errorText={folderName?.length ? '' : 'Введите название'}
            typeValid="custom"
          />
        </div>
      </div>
      <div className={mclasses.actions}>
        <Button color="gray" onClick={() => onClose()}>
          Отменить
        </Button>
        <Button
          color="primary"
          onClick={() => handleConfirm()}
          disabled={!folderName?.length || submitting}
          isLoading={submitting}
        >
          Подтвердить
        </Button>
      </div>
    </div>
  )
}

const CreateEditFolderModal: FC<CreateEditFolderModalProps> = (props) => {
  const { open, onClose } = props

  return (
    <Modal
      active={open}
      className={cn(mclasses.modalWrapper, classes.modalWrapper) as any}
      setActive={() => onClose()}
    >
      <CreateEditFolderModalContent {...props} />
    </Modal>
  )
}

export default CreateEditFolderModal
